// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type BookingContextProperties = {
  booking_uuid: string;
  shown_passenger_components?: string[];
  final_currency?: string;
  final_price_in_cents?: number;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/booking_context/jsonschema/4-0-0';
export const bookingContextName = 'booking_context';
export class BookingContext extends BaseTrackingContext<BookingContextProperties> {
  constructor(properties: BookingContextProperties) {
    super(bookingContextName, schema, properties);
  }
}
